<template>
  <div
    class="ds-note"
    :class="variant"
    :role="live"
    :aria-live="live === 'alert' ? 'assertive' : (live ? 'polite' : null)"
    :aria-atomic="live ? 'true' : null"
  >
    <slot />
  </div>
</template>

<script>
export const DS_NOTE_VARIANTS = ['quiet', 'success', 'warn', 'danger']
export const DS_NOTE_LIVE = ['status', 'alert']

// Callout for guidance that sits between a card's fields.
export default {
  name: 'DsNote',
  props: {
    variant: {
      type: String,
      default: 'quiet',
      validator: value => DS_NOTE_VARIANTS.includes(value),
    },
    // Set when the note appears in response to something the user did, so screen readers
    // announce it: 'status' for an outcome, 'alert' for a failure. b-alert did this by
    // default; a note used for static guidance should leave it off so nothing is announced
    // on mount. One prop rather than three attributes per call site.
    live: {
      type: String,
      default: null,
      validator: value => DS_NOTE_LIVE.includes(value),
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-note {
  padding: 12px 15px;
  font-size: 12.5px;
  line-height: 1.6;
  color: $c-text-sec;

  ::v-deep strong { color: $c-text; }

  ::v-deep a { color: $c-orange; }

  &.quiet {
    @include ds-inset-row;
  }

  &.success {
    background: $c-success-light;
    border: 1px solid rgba($c-success, 0.25);
    border-left: 3px solid $c-success;
    border-radius: 12px;
    // #1f7a45 rather than $c-success: 4.86:1 on this tint, where $c-success is 3.6:1.
    color: #1f7a45;

    ::v-deep strong { color: #1f7a45; }
  }

  &.warn {
    background: $c-orange-light;
    border: 1px solid rgba($c-orange, 0.22);
    border-left: 3px solid $c-orange;
    border-radius: 12px;
  }

  &.danger {
    background: $c-danger-light;
    border: 1px solid rgba($c-danger, 0.2);
    border-left: 3px solid $c-danger;
    border-radius: 12px;
    color: $c-danger-text;

    ::v-deep strong { color: $c-danger-text; }
  }
}
</style>
